angular.module('rjmNg.services').factory "cloudbiConnectionUtils", [
  "connectionUtils"
  "CONNECTIONS"
  "$clientAppUrl"
  (
    connectionUtils
    CONNECTIONS
    $clientAppUrl
  ) ->

    AWS_IP_ADDRESS_STR = "<strong>54.88.76.97</strong> and <strong>34.250.211.151</strong>"

    getAPIConnectionLink = (connection) ->
      id = connection.meta_id
      uiConfig = connectionUtils.getUIConfigForConnection connection
      return $clientAppUrl("/settings/connection/#{uiConfig.route}/#{id}/")

    getConnectionLink = (connection) ->
      type = connection.type
      if type in CONNECTIONS.DB_TYPES
        $clientAppUrl("/settings/connection/#{connection.meta_id}/")
      else
        getAPIConnectionLink(connection)

    isDbNameOptional = (type) ->
      types = CONNECTIONS.TYPES
      type in [types.MONGO, types.MSSQL, types.MYSQL]

    isDbNameRequired = (type) ->
      types = CONNECTIONS.TYPES
      type in [types.REDSHIFT, types.POSTGRES]

    showDbName = (type) ->
      return @isDbNameOptional(type) or @isDbNameRequired(type)

    isAlwaysEncrypted = (type) ->
      type in []

    getAwsRegion = (input) ->
      return unless input?.match?

      REGION_MATCHER = /([a-z]{2}-[a-z]+-\d+)\.amazonaws\.com/
      match = input.match(REGION_MATCHER)
      if match?
        return match[1]

    {
      AWS_IP_ADDRESS_STR
      getConnectionLink
      isDbNameOptional
      isDbNameRequired
      showDbName
      isAlwaysEncrypted
      getAwsRegion
    }

]
